import React from 'react';
import PropTypes from 'prop-types';
import { ProgressMeter } from '@paypalcorp/pp-react';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var GoalProgressMeter = function GoalProgressMeter(_ref) {
  var max = _ref.max,
    value = _ref.value,
    steps = _ref.steps,
    title = _ref.title,
    className = _ref.className;
  var classObj = className ? {
    className: className
  } : {};
  return /*#__PURE__*/React.createElement(ProgressMeter, _extends({
    max: max,
    value: value,
    steps: steps,
    title: title
  }, classObj));
};
GoalProgressMeter.propTypes = {
  max: PropTypes.string,
  value: PropTypes.string,
  steps: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string
};

export { GoalProgressMeter };
